import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { TrainingCourseState } from 'app/_models/training/training-course-state';
import { TrainingCourseForUser } from 'app/_models/training/training-course-for-user.model';
import { NotificationService } from 'app/_services/notification.service';
import { TrainingService } from 'app/_services/training.service';
import { TrainingType } from 'app/_models/training/training-type';


@Component({
  selector: 'contractor-acceptance-list',
  templateUrl: './contractor-acceptance-list.component.html',
})
export class ContractorAcceptanceListComponent implements OnInit {
  public routeRole: any;
  public nextSection: any;

  public groupedTrainingCourses: TrainingCourseForUser[][];

  public TrainingCourseStateType = TrainingCourseState; // allow enum in template
  public TrainingType = TrainingType; // allow enum in template

  constructor(
    private trainingService: TrainingService,
    private notificationService: NotificationService,
    private globals: Globals,
  ) {
    this.routeRole = globals.user.routeRole;
  }

  ngOnInit() {
    this.setupPage();
  }

  private setupPage() {
    this.trainingService.getOutageAcceptanceListForCurrentContractorManager().subscribe(trainingCourses => {
      this.groupedTrainingCourses = this.groupByTrainingId(trainingCourses);
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Error', 'Could not load outage acceptance data');
    });
  }

  private groupByTrainingId(courses: TrainingCourseForUser[]): TrainingCourseForUser[][] {
    const groupedCourses: { [key: string]: TrainingCourseForUser[] } = {};

    courses.forEach(course => {
      const trainingId = course.course.trainingId;
      if (!groupedCourses[trainingId]) {
        groupedCourses[trainingId] = [];
      }
      groupedCourses[trainingId].push(course);
    });

    // sort
    Object.keys(groupedCourses).forEach(key => {
      const courses = groupedCourses[key];
      this.sortCourses(courses);
    });


    // filter out expired if there is a valid one since
    Object.keys(groupedCourses).forEach(key => {
      const courses = groupedCourses[key];

      const hasCompleted = courses.find(course => course.courseProgress === TrainingCourseState.Completed);

      if (hasCompleted) {
        groupedCourses[key] = courses.filter(course => course.courseProgress !== TrainingCourseState.Expired);
      }
    });

    // should show 'Take again' link?
    Object.keys(groupedCourses).forEach(key => {
      const courses = groupedCourses[key];

      const inProgress = courses.find(course => course.courseProgress === TrainingCourseState.InProgress || course.courseProgress === TrainingCourseState.NotStarted);

      if (inProgress) {
        courses.forEach(course => {
          course.hasOneInProgress = true;
        });
      }
    });

    // turn into an array
    return Object.keys(groupedCourses).map(key => groupedCourses[key]);
  }

  private sortCourses(courses: TrainingCourseForUser[]): TrainingCourseForUser[] {
    return courses.sort((a, b) => {
      // Sort by course progress
      const progressOrder = {
        [TrainingCourseState.NotStarted]: 0,
        [TrainingCourseState.InProgress]: 1,
        [TrainingCourseState.Completed]: 2,
        [TrainingCourseState.Expired]: 3,
      };
      const progressDiff = progressOrder[a.courseProgress] - progressOrder[b.courseProgress];
      if (progressDiff !== 0) {
        return progressDiff;
      }

      // Sort by expiry date within each progress group
      if (!a.expiryDate || !b.expiryDate) {return 0};
      return b.expiryDate.getTime() - a.expiryDate.getTime();
    });
  }
}
